import type { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { IconButton } from './common';

interface IFullScreenProps {
    children: ReactNode;
    handleClose: () => void;
}

export function FullScreen(props: IFullScreenProps) {
    return ReactDOM.createPortal(
        <div className="full-screen">
            {props.children}
            <IconButton
                className="close-full-screen"
                icon="exit"
                inputType="button"
                onClick={async () => {
                    props.handleClose();
                }}
            />
        </div>,
        document.body
    );
}
